// extracted by mini-css-extract-plugin
module.exports = {"label":"_1G921gbL","rate":"_2nyo2WAT","valueSection":"_37xvg0qX"};